import { createRoot } from 'react-dom/client';

import Form from './_src/components/RecruitForm';

createRoot(document.querySelector('#form')).render(<Form />);